export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <g stroke="#0EA5E9" strokeWidth="2.5" strokeLinecap="round">
      <circle cx="24" cy="24" r="15" />
      <path d="M39 24 L21 29.2" />
      <path d="M31.5 36.99 L18 24" />
      <path d="M16.5 36.99 L21 18.8" />
      <path d="M9 24 L27 18.8" />
      <path d="M16.5 11.01 L30 24" />
      <path d="M31.5 11.01 L27 29.2" />
    </g>
    <circle cx="24" cy="24" r="2.2" fill="#0EA5E9" />
  </svg>
);

const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark size={compact ? 28 : 34} />
    <div className="leading-none">
      <span className="font-display font-black uppercase tracking-[0.18em] text-xl text-gray-50">
        Auto<span className="text-sky-500">ric</span>
      </span>
      {!compact && (
        <span className="block font-mono text-[9px] uppercase tracking-[0.3em] text-gray-500 mt-1">
          Dash Cam Install
        </span>
      )}
    </div>
  </div>
);

export default Logo;
